import { currencyInput } from '@/_schemas/generic';

import { type InvoiceFormSchema, type InvoiceQuerySchema } from '../schemas';
import { executionStatusValues, invoiceLifecycleStatusValues } from '../schemas/status-options';

export function invoiceQueryToForm({
  invoice_date,
  notes,
  status,
  execution_status,
  agreement_links,
  client,
  invoice_amount,
  due_date,
  ...data
}: InvoiceQuerySchema): InvoiceFormSchema {
  return {
    ...data,
    invoice_date: invoice_date || '',
    due_date: due_date || null,
    invoice_amount: currencyInput.queryToFormConverter(invoice_amount),
    notes: notes || '',
    status: status && invoiceLifecycleStatusValues.has(status) ? status : null,
    execution_status: execution_status && executionStatusValues.has(execution_status) ? execution_status : null,
    agreement_links: agreement_links || [],
    client: client || { id: -1, name: '', logo: null, account_number: null },
  };
}
